export const removeFromFavoritesText = "Een6zc";
export default {removeFromFavoritesText};